/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import type { SearchResultItem } from '../../api/search/search.types';
import { getPriceRange } from '../utils/price';

import styles from './CardPrice.module.scss';

interface CardPriceProps {
    item: SearchResultItem;
    className?: string;
}

export function CardPrice({ item, className }: CardPriceProps) {
    const { priceRangeLabel, priceRangeUnit, priceRangeAriaLabel } = getPriceRange(item);

    if (!priceRangeLabel) return null;

    return (
        <div className={cx(styles.price, className)}>
            <span aria-hidden="true">{priceRangeLabel}</span>

            {priceRangeUnit ? (
                <span className={styles.rangeUnit} aria-hidden="true">
                    {priceRangeUnit}
                </span>
            ) : null}

            <div className="rec-sr-only">{priceRangeAriaLabel}</div>
        </div>
    );
}
